var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef, useEffect, useMemo, useRef } from 'react';
import Select, { components } from 'react-select';
import './input-select-icons.spec';
import './input-select-icons.scss';
var InputSelectIcons = forwardRef(function (_a, ref) {
    var id = _a.id, options = _a.options, required = _a.required, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, setValue = _a.setValue, value = _a.value, SingleValue = _a.SingleValue, 
    // isApplicantPage,
    _b = _a.anchorPos, 
    // isApplicantPage,
    anchorPos = _b === void 0 ? 'left' : _b, extraProps = __rest(_a, ["id", "options", "required", "disabled", "error", "onChange", "setValue", "value", "SingleValue", "anchorPos"]);
    var selectRef = useRef(null);
    var classNamePrefix = useMemo(function () {
        var _a;
        return (_a = extraProps === null || extraProps === void 0 ? void 0 : extraProps.classNamePrefix) !== null && _a !== void 0 ? _a : 'reactselect';
    }, [extraProps === null || extraProps === void 0 ? void 0 : extraProps.classNamePrefix]);
    var className = useMemo(function () {
        return "react-select-container ".concat(anchorPos === 'right' ? 'react-select-right' : 'react-select-left', " ").concat(extraProps === null || extraProps === void 0 ? void 0 : extraProps.className);
    }, [anchorPos, extraProps === null || extraProps === void 0 ? void 0 : extraProps.className]);
    useEffect(function () {
        if (ref) {
            if (typeof ref === 'function') {
                ref(selectRef.current);
            }
            else if (ref) {
                ref.current = selectRef.current;
            }
        }
    }, [ref]);
    var customOption = function (props) {
        var _a;
        return (React.createElement("ul", null,
            React.createElement(components.Option, __assign({}, props),
                React.createElement("div", { className: "option-item" },
                    props.data.icon && React.createElement(props.data.icon, null),
                    React.createElement("span", { className: "option-label" }, (_a = props.data.displayText) !== null && _a !== void 0 ? _a : props.data.label)))));
    };
    var CustomSingleValue = function (props) { return (React.createElement(components.SingleValue, __assign({}, props), SingleValue ? SingleValue : 'Please select')); };
    var handleChange = function (selectedOption) {
        if (onChange) {
            if ((value || value === 0) && setValue) {
                setValue(id, value);
            }
            var syntheticEvent = {
                target: {
                    name: id,
                    value: selectedOption ? selectedOption.value : '',
                },
            };
            onChange(syntheticEvent);
        }
    };
    var groupedOptions = options.reduce(function (acc, option) {
        var _a;
        var group = (_a = option.category) !== null && _a !== void 0 ? _a : '';
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push(option);
        return acc;
    }, {});
    var selectOptions = Object.keys(groupedOptions)
        .filter(function (key) { return key !== 'Others'; })
        .map(function (key) { return ({
        label: key,
        options: groupedOptions[key].map(function (option) {
            var _a;
            return ({
                value: option.id,
                label: (_a = option.displayText) !== null && _a !== void 0 ? _a : option.value,
                icon: option.icon,
            });
        }),
    }); });
    return (React.createElement("div", { className: "c-input-select-newClient-wrapper".concat(error ? ' isInvalid' : '').concat(required ? ' isRequired' : '') },
        React.createElement(Select, __assign({ name: id, id: id, onMenuOpen: function () {
                setValue(id, 0);
            }, options: selectOptions, onChange: handleChange, components: { Option: customOption, SingleValue: CustomSingleValue }, isDisabled: disabled, ref: selectRef, value: value === 0
                ? null
                : selectOptions.flatMap(function (group) { return group.options; }).find(function (opt) { return opt.value === value; }), isSearchable: false }, extraProps, { classNamePrefix: classNamePrefix, className: className }))));
});
InputSelectIcons.displayName = 'InputSelectIcons';
export default InputSelectIcons;
